import cn from 'classnames';
import type React from 'react';
import * as st from './styles.module.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'active' | 'dark';
  size?: 'small' | 'medium' | 'large';
  children?: React.ReactNode;
  className?: string;
}

export const TextButton: React.FC<Props> = ({
  variant = 'active',
  size = 'medium',
  children,
  className,
  ...props
}) => {
  return (
    <button className={cn(st.btn, st[size], st[variant], className)} {...props}>
      {children}
    </button>
  );
};
